import { render, staticRenderFns } from "./OrderPackageModal.vue?vue&type=template&id=3d5523c4&scoped=true&"
import script from "./OrderPackageModal.vue?vue&type=script&lang=js&"
export * from "./OrderPackageModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5523c4",
  null
  
)

export default component.exports